<h2>{{ 'logos' | translate }}</h2>
<app-logos [id]="id" (logosData)="receiveLogosData($event)" ></app-logos>